module.exports = __webpack_public_path__ + "static/img/02.49612d88.png";